import * as actionTypes from './actionTypes'

const operatorDetails = JSON.parse(localStorage.getItem('operator-details')) || {};
// if token is present
const isLoggedIn = !!operatorDetails.access_token;

const initialState = {
  isLoggedIn: isLoggedIn,
  userInfo: {},
  operatorDetails: operatorDetails || {},
  allRoutesInfo: {},
  merchantCode: '',
  escalationMatrix: [],
  operatorInfo: {
    isKsrtc: false,
    isApsrtc: false
  }
  // access_token: '',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.LOGIN_SUCCESS:
      return { ...state, isLoggedIn: true };
    case actionTypes.USER_INFO: 
      return { ...state, userInfo: payload.data };
    case actionTypes.LOGOUT_SUCCESS:
      return { ...initialState, isLoggedIn: false };
    case actionTypes.TOKEN_SUCCESS:
      return { ...state, operatorDetails: payload, isLoggedIn: true }
    case actionTypes.ALL_ROUTES_INFO: {
      return {
        ...state,
        allRoutesInfo: payload
      }
    }
    case actionTypes.SET_MERCHANT_ID: {
      return { ...state, merchantCode: payload }
    }
    case actionTypes.SET_ESCALATION_MATRIX: {
      return { ...state, escalationMatrix: payload }
    }
    case actionTypes.SET_OPERATOR_TYPE: {
      return { ...state, operatorInfo: payload}
    }
    default:
      return state
  }
}
